import endpoints from 'constants/endpoints';
import createUserState from 'helpers/factory/userFactory';
import { safePostCall } from 'helpers/firebaseSetup';
import { parseZohoJsonOutput } from 'helpers/zoho/response-parsers';

export const getUser = async firebaseData => {
  const zohoRes = await safePostCall(endpoints.awsProxy.genericPost, {
    googleId: firebaseData.user.uid,
    zohoId: false,
    endpoint: endpoints.zoho.getAgent,
    isZohoRequest: true
  });
  const result = parseZohoJsonOutput(zohoRes?.data?.details?.output);
  if (!result.ok) {
    throw new Error(result.message || 'User not found');
  }
  const zohoData = result.data.agent;
  return {
    data: createUserState(zohoData, firebaseData),
    mainZohoId: zohoData.id
  };
};
